import React from 'react'
import { connect } from "react-redux"
import PropTypes from "prop-types"
import ReactMarkdown from 'react-markdown'

import ItemTemplate from './ItemTemplate'
import SimpleModal from '../../components/SimpleModal'
import ActivityDetails from '../../routes/ActivityDetails.jsx'

import { linkifyMarkdown } from "../../../lib/Tools"
import { nameOrTitle, getText } from '../../lib/text.js'
import * as uiActions from '../../actions/ui'

const infoBox = {
  overflowY: "hidden",
  textOverflow: "ellipsis",
  maxHeight: "150px",
  display: "block",
  whiteSpace: "wrap",
}

/**
 *
 */

class ActivityItem extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = {
      modal: false
    }
  }
  
  toggleModal(on = false) {
    this.props.toggleModal("Activity:infoModal", on)
    this.setState({ modal: on })
  }
  
  componentWillUnmount() {
    if (this.state.modal) {
      this.props.toggleModal("Activity:infoModal", false)
    }
  }
  
  renderDescription(maxHeight) {
    const { item, Activities } = this.props
    const transportation = item.recommendedTransportation && getText(`RT_${item.recommendedTransportation}`)
    const customFee = item.useCustomFee ? `${item.customFee}%` : null

    const notes = (
      Activities[item.id].notes != getText("Notas vacías")
      && Activities[item.id].notes != "Notas vacías"
      && Activities[item.id].notes
    )

    return (
      (notes || transportation || customFee)
        ? (
          <div style={maxHeight ? infoBox : {}}>
            {transportation && <div>Recomendación para llegar: {transportation}</div>}
            {customFee && <div>Gastos gestión: {customFee}</div>}
            {notes && <ReactMarkdown source={linkifyMarkdown(notes)} />}
          </div>
        )
        : ""
    )
  }

  render() {
    const { item, Activities } = this.props
    const notes = (
      Activities[item.id].notes != getText("Notas vacías")
      && Activities[item.id].notes != "Notas vacías"
      && Activities[item.id].notes
    )
    
    return (
      <ItemTemplate
        {...this.props}
        title={nameOrTitle(Activities[item.id])}
        subtitle={item.time ? `(${item.time})` : ""}
        description={(
          <div>
            {this.renderDescription(true)}
            {
              this.state.modal && (
                <SimpleModal
                  _id={item.id}
                  title={nameOrTitle(Activities[item.id])}
                  onClose={() => this.toggleModal(false)}
                >
                  {this.renderDescription(false)}
                </SimpleModal>
              )
            }
          </div>
        )}
        icon="triangle-right"
        modal={
          () => (
            <ActivityDetails
              {...this.props}
              title={nameOrTitle(Activities[item.id])}
              time={item.time || ""}
              onChange={this.props.editItem}
              onClose={() => this.props.onEndEdit()}
            />
          )
        }
        onInfo={notes && (() => this.toggleModal(true))}
      />
    )
  }
}

ActivityItem.propTypes = {
  item: PropTypes.object.isRequired,
  Activities: PropTypes.object.isRequired,
  toggleModal: PropTypes.func.isRequired,
  onEndEdit: PropTypes.func, // not required: doesnt appear while adding
  editItem: PropTypes.func,
}

const mapStateToProps = _state => ({})

const mapDispatchToProps = dispatch => ({
  toggleModal: (key, inModal) => dispatch(uiActions.toggleModal(key, inModal))
})

export default connect(mapStateToProps, mapDispatchToProps)(ActivityItem)
